module.exports = __webpack_public_path__ + "static/media/dmg.67d975a4.png";